import React from 'react';
export const FormulaSection = () => {
  return <div className="my-16" data-id="element-93">
      <h2 className="text-3xl font-bold mb-8" data-id="element-94">
        So, I Decided To Create My Own Formula
      </h2>
      <div className="flex justify-center mb-8" data-id="element-95">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/17a8tgWVWQtxpS74SriN6y/Scientists.jpg" alt="Scientists in lab with Drift product" className="rounded-lg w-full max-w-4xl" data-id="element-96" />
      </div>
      <div className="mt-8" data-id="element-97">
        <p className="text-lg mb-4" data-id="element-98">
          After seeing this combination change the lives of thousands of my
          patients, I knew I had to make it available to men everywhere.
        </p>
        <p className="text-lg mb-4" data-id="element-99">
          That's when I partnered with Thaura, a research-first nutraceutical
          company, to create Drift™.
        </p>
        <p className="text-lg mb-4" data-id="element-100">
          Drift™ is the first and only formula to combine all five of these
          powerful compounds in their clinically effective forms and doses. We
          spent over two years sourcing the highest-quality raw materials. Every
          single batch is third-party tested for purity and potency.
        </p>
      </div>
    </div>;
};